import { Dealer } from '../../gql/graphql';

/**
 * Plaid is enabled per dealer by AES (Unleash `plaid_merchant_allow_list` ->
 * `Dealer.supportsExternalBankConnector`). UUI has no flag of its own for it.
 */
export const determinePlaidFF = (context: { dealer: Dealer }): boolean => !!context.dealer?.supportsExternalBankConnector;
